import React from 'react';
interface QuotationHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    email: string;
    uen: string;
  };
  quotation: {
    number: string;
    date: string;
    validUntil: string;
    currency: string;
    bookingReference: string;
    salesOwner: string;
  };
}
export function QuotationHeader({
  company,
  quotation
}: QuotationHeaderProps) {
  return <>
      {/* Top Header */}
      <div className="flex justify-between items-start mb-8" data-id="element-887">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-888">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-889">
            <span className="text-white font-bold text-xl" data-id="element-890">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-891">
            {company.name}
          </h1>
          <div className="text-xs text-neutral-600 space-y-0.5 leading-relaxed" data-id="element-892">
            {company.address.map((line, i) => <p key={i} data-id="element-893">{line}</p>)}
            <p className="mt-2" data-id="element-894">Tel: {company.phone}</p>
            <p data-id="element-895">Email: {company.email}</p>
            <p data-id="element-896">UEN: {company.uen}</p>
          </div>
        </div>

        {/* Right: Quotation Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-897">
          <div className="space-y-2" data-id="element-898">
            <div className="flex justify-between" data-id="element-899">
              <span className="text-xs font-medium text-neutral-600" data-id="element-900">
                Quote Number:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-901">
                {quotation.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-902">
              <span className="text-xs font-medium text-neutral-600" data-id="element-903">
                Quote Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-904">{quotation.date}</span>
            </div>
            <div className="flex justify-between" data-id="element-905">
              <span className="text-xs font-medium text-neutral-600" data-id="element-906">
                Valid Until:
              </span>
              <span className="text-xs font-semibold text-red-600" data-id="element-907">
                {quotation.validUntil}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-908">
              <span className="text-xs font-medium text-neutral-600" data-id="element-909">
                Currency:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-910">
                {quotation.currency}
              </span>
            </div>
            <div className="h-px bg-neutral-200 my-2" data-id="element-911" />
            <div className="flex justify-between" data-id="element-912">
              <span className="text-xs font-medium text-neutral-600" data-id="element-913">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-914">
                {quotation.bookingReference}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-915">
              <span className="text-xs font-medium text-neutral-600" data-id="element-916">
                Sales Owner:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-917">
                {quotation.salesOwner}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <div className="text-center mb-6" data-id="element-918">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight" data-id="element-919">
          CUSTOMIZED TOUR QUOTATION
        </h2>
      </div>
    </>;
}